import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GenerativeAi } from "./generativeAi/generativeAi";
import {
  Field,
  Form,
  FormElement,
  FormRenderProps,
} from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { Alert, FormLabeledInput, FormMultiSelectAdd } from "@mikros/shared-ui";
import { FormTextArea } from "@mikros/shared-ui";
import { Manual } from "./manual/manual";
import Spinner from "../../utils/Loader";
import {
  Chapter as C,
  Card,
  CardInfo,
  Cards,
  ChapterData,
  CourseChapter,
  CourseModuleCards,
  GenerativeAiChapters,
  GenerativeAiPost,
  CreateCourse as CC,
  ManualChapter,
  GenerativeAiRequestCards,
  Question,
} from "@mikros/library";
import ApiServices from "../../service/apiService";
import { FormattedMessage, useIntl } from "react-intl";
import { v4 } from "uuid";
import S3Service from "../../service/s3Service";
import { toast } from "react-hot-toast";
import { PdfGenerativeAi } from "./pdfGenerativeAi/pdfGenerativeAi";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Loading } from "../common/loading";
import Account from "../../utils/apiConfig";
import ErrorHandler from "../../utils/errorConfig";
import { events } from "aws-amplify/api";
import AuthService from "../../service/authService";
import { jwtDecode } from "jwt-decode";

export interface CreateCourseProps {}

export function CreateCourse(props: CreateCourseProps) {
  const intl = useIntl();
  const generativeAiScreen = intl.formatMessage({
    id: "courses.model.options.generativeAi",
  });
  const generativeAiFileScreen = intl.formatMessage({
    id: "courses.model.options.generativeAiFromFile",
  });
  const manualScreen = intl.formatMessage({
    id: "courses.model.options.manual",
  });
  const courseCatalogueScreen = intl.formatMessage({
    id: "courses.model.options.fromCatalogue",
  });

  const navigate = useNavigate();
  const location = useLocation();
  const spinner = new Spinner();
  const accountInstance = Account.getInstance();
  const errorInstance = ErrorHandler.getErrorInstance();
  const [loading, setLoading] = useState(false);

  // This is only for Manual cards
  const [manualCourse, setManualCourse] = useState<CourseModuleCards>({
    chapters: [
      {
        cards: [{ cardInfo: { card: [{} as Card] } as CardInfo } as Cards],
        questions: [] as Question[],
      } as CourseChapter,
    ],
  } as CourseModuleCards);

  const [courseName, setCourseName] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [oneChapterDelete, setOneChapterDelete] = useState<boolean>(false);
  console.log("print bool value of one chapter delete", oneChapterDelete);
  const [isCourseCreated, setIsCourseCreated] = useState<boolean>(false);

  const [changesSaved, setChangesSaved] = useState(false);
  const [resApi, setresApi] = useState<any>({});
  const [uploadError, setUploadError] = useState<boolean>(false);
  const [uploadImageError, setUploadImageError] = useState<boolean>(false);
  const [uploadVideoError, setUploadVideoError] = useState<boolean>(false);
  const [uploadAudioError, setUploadAudioError] = useState<boolean>(false);

  useState<string>("");

  console.log("resapi zzzzzz", resApi);

  useEffect(() => {
    console.log("res api", resApi);
  }, [resApi]);

  const [copy, setCopy] = useState<CourseModuleCards>();

  const [quickSaveDialog, setQuickSaveDialog] = useState<boolean>(false);
  const [submitDialog, setSubmitDialog] = useState<boolean>(false);

  const [clickSave, setClickSave] = useState(true);

  const [sub, setSub] = useState(null);
  const subRef = useRef(null);

  //error
  const [errorFlag, setErrorFlag] = useState<boolean>(false);
  console.log("print error flag inside create", errorFlag);

  console.log("quick save", clickSave);
  console.log("submit dialog", submitDialog);



  useEffect(() => {
    async function fetchSub() {
      let a = await AuthService.getInstance().getIdToken();
      console.log("id token course", a);
      const decoded: any = jwtDecode(a);
      const subValue = decoded["sub"];
      setSub(subValue);
      subRef.current = subValue;
      console.log("print tenant id inside use effect of edit course", subValue);
    }
    fetchSub();
  }, []);

  const apiCreateManualCourse = async (
    course: CC,
    chaptersCards: any[],
    manualCourse: CourseModuleCards
  ): Promise<boolean> => {
    if (courseName === "" || description === "") {
      return false;
    }

    console.log("chapter cards inside api create manual", chaptersCards);

    let newCC = { source: "MANUAL", ...course };

    // newCC.source = "MANUAL"
    let api = ApiServices.getInstance();
    console.log("overAll", chaptersCards);
    console.log("overAll", course);
    if (accountInstance.accntId) {
      if (isCourseCreated) {
        setCopy(manualCourse);
        return apiUpdateManualCards(course.courseId, chaptersCards);
      } else {
        return api
          .makeRequest(`${accountInstance.accntId}/course`, "POST", newCC)
          .then(async (res) => {
            if (res && res.errorMessage) {
              setErrorFlag(true);
              await errorInstance.updateErrorCode(res.errorMessage);
              return false;
            }
            console.log("Manual Course created", res);

            setIsCourseCreated(true);
            setCopy(manualCourse);
            return apiUpdateManualCards(res.courseId, chaptersCards);
          })
          .catch((err) => {
            return false;
          });
      }
    } else {
      return false;
    }
  };

  const toggleUploadErrorDialog = () => {
    setUploadError(!uploadError);
  };
  const toggleQuickSaveDialog = () => {
    setQuickSaveDialog(!quickSaveDialog);
  };
  const toggleSubmitDialog = () => {
    setSubmitDialog(!submitDialog);
  };

  const apigetPresignedUrl = async (courseId: any, filePath: string) => {
    console.log("inside create course api ");
    console.log("inside api,courseId", courseId);
    console.log("inside api,filePath ", filePath);
    let body = {
      filePath: filePath,
    };
    let api = ApiServices.getInstance();

    let apiCall = {} as any;
    if (accountInstance.accntId) {
      apiCall = await api.makeRequest(
        `${accountInstance.accntId}/course/${courseId}`,
        "POST",
        body
      );
    }
    if (apiCall) {
      console.log("api call", apiCall);
      return apiCall;
    }
  };

  const readerUpload = (e: any) =>
    new Promise<object>((resolve, reject) => {
      const reader = new FileReader();
      let s3 = S3Service.getInstance();
      let element = e.fileName;
      console.log("print file name", element);

      reader.readAsDataURL(element);
      reader.onload = async () => {
        let file = s3.convertToFile(reader.result, element.type, element.name);
        console.log("file reader", file);
        if (e.cardType === "VIDEO") {
          await s3
            .writeFileInFolder(
              e.filePath,
              file,
              "Mikros-Cards",
              e.fileName.type
            )
            .then(async (res) => {
              let url = (await apigetPresignedUrl(
                particularCourseDetails.courseId,
                e.cardInfo.card[0].url
              )) as any;
              resolve(url);
            })
            .catch((e) => {
              // toast.error("Something went wrong");
              setUploadVideoError(true);
              toggleUploadErrorDialog();
              reject(e);
            });
        } else if (e.cardType === "AUDIO") {
          await s3
            .writeFileInFolder(
              e.filePath,
              file,
              "Mikros-Cards",
              e.fileName.type
            )
            .then(async (res) => {
              let url = (await apigetPresignedUrl(
                particularCourseDetails.courseId,
                e.cardInfo.card[0].url
              )) as any;
              resolve(url);
            })
            .catch((e) => {
              // toast.error("Something went wrong");
              setUploadAudioError(true);
              toggleUploadErrorDialog();
              reject(e);
            });
        } else if (e.cardType === "IMG") {
          console.log("entered image card ");
          await s3
            .writeFileInFolder(
              e.filePath,
              file,
              "Mikros-Cards",
              e.fileName.type
            )
            .then(async (res) => {
              let url = (await apigetPresignedUrl(
                particularCourseDetails.courseId,
                e.cardInfo.card[0].url
              )) as any;
              console.log("Success and will be resolving", url);
              resolve(url);
            })
            .catch((e) => {
              // toast.error("Something went wrong");
              setUploadImageError(true);
              toggleUploadErrorDialog();
              reject(e);
            });
        }
      };
    });

    const handleVideoGeneration = async (e: any): Promise<any> => {
      console.log("inside handle video generation of edit course", e);
  
      const body = {
        courseName: e.courseName,
        chapterName: e.chapterName,
        courseId: e.courseId,
        chapterId: e.chapterId,
        cardId: e.cardId,
        accntId: accountInstance.accntId,
        createdBy: e.createdBy,
        prompt: e.prompt,
        userId: subRef.current,
        cardType:e.cardType
      };
      console.log("body in edit course handle video generation", body);
  
      const accntId = body.accntId;
      const courseId = body.courseId;
  
      const endpoint = `${accntId}/course/${courseId}/genVideo`;
  
      const api = ApiServices.getInstance();
  
      if (accntId) {
        return await api
          .makeRequest(endpoint, "POST", body)
          .then(async (res) => {
            if (res && res.errorMessage) {
              setErrorFlag(true);
              if (errorInstance && errorInstance.updateErrorCode) {
                await errorInstance.updateErrorCode(res.errorMessage);
              }
              return false;
            }
            console.log("Video generation response:", res);
            return res;
          })
          .catch(async (err) => {
            setErrorFlag(true);
            if (errorInstance && errorInstance.updateErrorCode) {
              await errorInstance.updateErrorCode("Video generation failed");
            }
            return false;
          });
      } else {
        return false;
      }
    };

    // const handleAudioGeneration = async (e: any): Promise<string | false> => {
    //   console.log("Inside handle audio generation of create course", e);
  
    //   const body = {
    //     courseId: e.courseId,
    //     chapterId: e.chapterId,
    //     cardId: e.cardId,
    //     accntId: accountInstance.accntId,
    //     createdBy: e.createdBy,
    //     prompt: e.prompt,
    //     cardType: e.cardType,
    //     language: e.language,
    //     languageCode: e.languageCode,
    //     style: e.style,
    //     voiceName: e.voiceName,
    //   };
    //   const accntId = body.accntId;
    //   const courseId = body.courseId;
  
    //   const endpoint = `${accntId}/course/${courseId}/genAudio`;
    //   const api = ApiServices.getInstance();
  
    //   if (!accntId) {
    //     return false;
    //   }
    //   try {
    //     const res = await api.makeRequest(endpoint, "POST", body);
    //     if (res && res.errorMessage) {
    //       setErrorFlag(true);
    //       if (errorInstance && errorInstance.updateErrorCode) {
    //         await errorInstance.updateErrorCode(res.errorMessage);
    //       }
    //       console.log("audio error response", res);
    //       return false;
    //     }
    //     console.log("Audio generation API response", res);
    //     const parsedBody = JSON.parse(res.body);
    //     const presignedUrl = parsedBody.presignedUrl;
    //     console.log("Presigned url audio being sent in create", presignedUrl);
    //     return presignedUrl;
    //   } catch (err) {
    //     console.error("Error in handle audio gen", err);
    //     setErrorFlag(true);
    //     if (errorInstance && errorInstance.updateErrorCode) {
    //       await errorInstance.updateErrorCode("Audio gen failed");
    //     }
    //     return false;
    //   }
    // };


    const handleAudioGeneration = async (
      e: any
    ): Promise<{ presignedUrl: string; prompt: string } | false> => {
      console.log("Inside handle audio generation of create course", e);
    
      const body = {
        courseId: e.courseId,
        chapterId: e.chapterId,
        cardId: e.cardId,
        accntId: accountInstance.accntId,
        createdBy: e.createdBy,
        prompt: e.prompt,
        cardType: e.cardType,
        language: e.language,
        languageCode: e.languageCode,
        style: e.style,
        voiceName: e.voiceName,
      };
      const accntId = body.accntId;
      const courseId = body.courseId;
    
      const endpoint = `${accntId}/course/${courseId}/genAudio`;
      const api = ApiServices.getInstance();
    
      if (!accntId) {
        return false;
      }
      try {
        const res = await api.makeRequest(endpoint, "POST", body);
        if (res && res.errorMessage) {
          setErrorFlag(true);
          if (errorInstance && errorInstance.updateErrorCode) {
            await errorInstance.updateErrorCode(res.errorMessage);
          }
          console.log("audio error response", res);
          return false;
        }
        console.log("Audio generation API response", res);
        const parsedBody = JSON.parse(res.body);
    
        const presignedUrl = parsedBody.presignedUrl;
        const prompt = parsedBody.prompt; // extract prompt
    
        console.log("Prompt returned in create", prompt);
        console.log("Presigned url audio being sent in create", presignedUrl);
    
    
        return { presignedUrl, prompt };
      } catch (err) {
        console.error("Error in handle audio gen", err);
        setErrorFlag(true);
        if (errorInstance && errorInstance.updateErrorCode) {
          await errorInstance.updateErrorCode("Audio gen failed");
        }
        return false;
      }
    };
    

    const handleImageGeneration = async (e: any): Promise<string | false> => {
      console.log("inside handle image generation of create course", e);
  
      const body = {
        courseId: e.courseId,
        chapterId: e.chapterId,
        cardId: e.cardId,
        accntId: accountInstance.accntId,
        createdBy: e.createdBy,
        prompt: e.prompt,
        cardType: e.cardType,
      };
  
      const accntId = body.accntId;
      const courseId = body.courseId;
      // const endpoint = `${accntId}/course/${courseId}/genMedia`;
      const endpoint = `${accntId}/course/${courseId}/genImage`;
      const api = ApiServices.getInstance();
  
      if (!accntId) return false;
  
      const channelPath = `/default/${body.cardId}`;
  
      try {
        console.log("Connecting to:", channelPath);
        const channel = await events.connect(channelPath);
        console.log("Connected to channel:", channel);
  
        const presignedUrl: string = await new Promise((resolve, reject) => {
          channel.subscribe({
            next: (data) => {
              console.log("Received data from channel subscription", data);
              try {
                // ONLY parse if it’s still a JSON string
                const eventData =
                  typeof data.event === "string"
                    ? JSON.parse(data.event)
                    : data.event;
  
                const url = eventData?.presignedUrl;
                if (!url) throw new Error("presignedUrl missing");
  
                console.log("Presigned URL:", url);
                resolve(url);
              } catch (err) {
                reject("Failed to extract presignedUrl: " + err);
              }
            },
            error: (err) => {
              console.error("Error in channel subscription", err);
              // setLoading(false);
              // spinner.hideSpinner();
              reject("Channel subscription error");
            },
          });
  
          console.log(
            "Subscribed to channel. Now sending video generation request..."
          );
  
          // Fire API after subscription starts listening
          api.makeRequest(endpoint, "POST", body).then((res) => {
            if (res && res.errorMessage) {
              setErrorFlag(true);
              if (errorInstance && errorInstance.updateErrorCode) {
                errorInstance.updateErrorCode(res.errorMessage);
              }
              // spinner.hideSpinner();
              // setLoading(false);
              reject("API returned error");
            }
            console.log("Image generation API response:", res);
          });
        });
        // setLoading(false);
        // spinner.hideSpinner();
        return presignedUrl;
      } catch (err) {
        console.error("Error in handleImageGeneration:", err);
        // spinner.hideSpinner();
        // setLoading(false);
        setErrorFlag(true);
        if (errorInstance && errorInstance.updateErrorCode) {
          await errorInstance.updateErrorCode("Image generation failed");
        }
        return false;
      }
  
      return false;
    };

  const handleUploadGiveUrl = async (e: any) => {
    let url = {};

    if (
      e.cardType !== "TEXT" &&
      e.cardType !== "LINK" &&
      e.cardType !== "Text"
    ) {
      console.log("inside the type of non-text card");

      const reader = new FileReader();
      console.log("print file name before enter", e?.fileName);
      if (e?.fileName) {
        console.log("inside filename");

        url = await readerUpload(e);

        console.log("This is the url in the coourses", url);

        return url;
      }
    }
  };

  async function duplicateS3File(
    sourceKey: string,
    destinationKey: string,
    fileType: string
  ) {
    let s3 = S3Service.getInstance();
    const sourceKeyPath = sourceKey.split("/").slice(1).join("/");
    const sourceBucket = sourceKey.split("/")[0];

    const destinationKeyPath = destinationKey.split("/").slice(1).join("/");
    const destinationBucket = destinationKey.split("/")[0];
    const fileName = destinationKey.split("/").pop();
    const file = await s3.readFile(sourceKeyPath, sourceBucket);
    const fileData = await fetch(file);
    const blobData = await fileData.blob();
    const uploadablFile = new File([blobData], fileName as string);
    const resp = await s3.writeFileInFolder(
      destinationKeyPath,
      uploadablFile,
      destinationBucket,
      fileType
    );

    const url = await apigetPresignedUrl(
      particularCourseDetails.courseId,
      destinationKey
    );
    console.log("The copied url =>", url);
    return url?.url;
  }

  const apiUpdateManualCards = async (
    courseId: string,
    chaptersCards: any[]
  ): Promise<boolean> => {
    console.log("creating the chapters", chaptersCards);
    console.log("12445");
    console.log("This is the course id", courseId);
    let updateCourse = {
      courseId: courseId,
      courseName: courseName,
      description: description,
      chapter: chaptersCards,
    };

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      return await api
        .makeRequest(
          `${accountInstance.accntId}/course/${courseId}`,
          "PUT",
          updateCourse
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            console.log("I entered update course message 1");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return false;
            // return
          }
          console.log("Manual Course Chapters added", res);
          setChangesSaved(true);
          return true;
        })
        .catch((err) => {
          return false;
        });
    } else {
      return false;
    }
  };

  useEffect(() => {
    console.log("inside use effect create course");
    let data = manualCourse;
    const date = new Date();
    const uuid = v4();
    const cardId = v4();
    const chapterId = v4();
    data.courseId = uuid;
    data.accntId = accountInstance.accntId;
    data.date = date.toISOString();
    console.log("entered data chapters");
    data.chapters[0].chapterId = chapterId;
    data.chapters[0].courseId = uuid;
    data.chapters[0].seqNo = 1;
    data.chapters[0].entityId = v4();
    data.chapters[0].createdAt = date.toISOString();
    data.chapters[0].date = date.toISOString();
    data.chapters[0].isLastChapter = false;
    data.chapters[0].cards[0].cardId = cardId;
    data.chapters[0].cards[0].cardName = "card1";
    data.chapters[0].cards[0].cardType = "TEXT";
    data.chapters[0].cards[0].cardInfo.card[0].text = `${intl.formatMessage({
      id: "courses.createCourse.sampleText",
    })}`;
    data.chapters[0].chapterName = `${intl.formatMessage({
      id: "courses.createCourseChapterName",
    })}`;
    data.chapters[0].cards[0].seqNo = 1;
    data.chapters[0].cards[0].chapterId = chapterId;
    data.chapters[0].cards[0].description = "";
    data.chapters[0].cards[0].isLastCard = false;
    data.chapters[0].cards[0].cardInfo.cardId = cardId;
    data.chapters[0].cards[0].cardInfo.cardType = "TEXT";
    data.chapters[0].cards[0].url = "undefined";

    setManualCourse(data);

    console.log("entered use effect copy");
    const copy_Object = Object.assign({}, data);
    setCopy(copy_Object);
    sessionStorage.setItem("copy", JSON.stringify(copy_Object));
    console.log("props card data", data);
    console.log("copy object", copy_Object);
  }, []);

  useEffect(() => {
    console.log("entered sample chapter create");
    let data = manualCourse;
    data.courseName = courseName;
    data.description = description;
    setManualCourse(data);
  }, [courseName, description]);

  const handleCreateManualCourse = (
    chaptersCards: ManualChapter[],
    manualCourse: CourseModuleCards
  ): Promise<boolean> => {
    console.log("entered sample chapter create");
    let date = new Date();
    let course: CC = {
      accntId: accountInstance.accntId,
      courseName: courseName,
      createdBy: accountInstance.accntId,
      date: date.toISOString(),
      publishedBy: "",
      publishedDate: date.toISOString(),
      courseId: chaptersCards[0]?.courseId,
      reviewedBy: "",
      reviewedDate: "",
      updatedBy: "",
      description: description,
    };

    return apiCreateManualCourse(course, chaptersCards, manualCourse);
  };

  // This is only for generative ai create course form data and apis
  const [generativeAiInfo, setGenerativeAiInfo] = useState<GenerativeAiPost>(
    {} as GenerativeAiPost
  );
  const [disableFields, setDisableFields] = useState<boolean>(false);
  const [generatedChapters, setGeneratedChapters] =
    useState<GenerativeAiChapters>({
      data: { Chapters: [{} as C] } as ChapterData,
    } as GenerativeAiChapters);
  const [courseId, setCourseId] = useState<string>();

  const [particularCourseDetails, setParticularCourseDetails] =
    useState<CourseModuleCards>({
      chapters: [
        {
          cards: [{ cardInfo: { card: [{} as Card] } as CardInfo } as Cards],
        } as CourseChapter,
      ],
    } as CourseModuleCards);

  const handleDisableFields = () => {
    setDisableFields(!disableFields);
  };
  const apiCreateGenerativeAiCourse = (course: CC, chapterCnt: string) => {
    console.log("course in api create generative ai course", course);
    if (!course.accntId) {
      course.accntId = accountInstance.accntId;
    }

    let newCC = { source: "AI", ...course };
    toast.custom(<Loading />, { duration: Infinity });
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequestWithoutSpinner(
          `${accountInstance.accntId}/course`,
          "POST",
          newCC
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("course created", res);
          let info = generativeAiInfo;
          info.chapterscount = chapterCnt;
          info.courseName = course.courseName;
          info.focusarea = course.description;
          info.temporaryId = "ID!";
          setCourseId(res.courseId);
          setLoading(true);
          spinner.showSpinner();
          apiCallGenerativeAiChapters(info, res.courseId);
        });
    }
  };

  const [pullContentChapters, setPullContentChapters] = useState<any>();

  const fetchAiChaptersPoll = async (
    courseId: string,
    chapterCount: string,
    temporaryId: string
  ) => {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequestWithoutSpinner(
          `${accountInstance.accntId}/course/${courseId}/aicourse/aichapter/pullcontent`,
          "POST",
          { chapterCount, temporaryId }
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          if (typeof res !== "string") {
            console.log(res);
            setPullContentChapters(res);
            spinner.hideSpinner();
            toast.remove();
          }
        });
    }
  };

  useEffect(() => {
    console.log("Polled Response", pullContentChapters);
    if (
      typeof pullContentChapters !== "string" &&
      typeof pullContentChapters !== "undefined"
    ) {
      setDisableFields(true);
      let chapters: GenerativeAiChapters = {
        status: "success",
        courseId: courseId,
        data: {
          courseName: pullContentChapters.courseName,
          Chapters: pullContentChapters.Chapters,
          TotalChapters: pullContentChapters.TotalChapters,
        },
      };

      for (let chapter of chapters.data.Chapters) {
        chapter.chapterId = v4();
      }

      setGeneratedChapters(chapters);
      setLoading(false);
      spinner.hideSpinner();
      clearTimeouts();
      sessionStorage.removeItem("courseId");
      sessionStorage.removeItem("temporaryId");
      sessionStorage.removeItem("chapterscount");
    }
  }, [pullContentChapters]);

  const [timeoutId, setTimeoutId] = useState<number[]>([]);
  const [timeOut, setChTimeOut] = useState<number>(0);
  sessionStorage.setItem("tempChTimeout", (0).toString());
  const pollForData = async (
    courseId: string,
    chapterCnt: string,
    temporaryId: string
  ): Promise<void> => {
    try {
      let response;
      if (
        courseId !== undefined &&
        chapterCnt !== undefined &&
        temporaryId !== undefined
      ) {
        response = await fetchAiChaptersPoll(courseId, chapterCnt, temporaryId);
      } else {
        const cId = sessionStorage.getItem("courseId");
        const tempId = sessionStorage.getItem("temporaryId");
        const chptCnt = sessionStorage.getItem("chapterscount");

        response = await fetchAiChaptersPoll(cId!!, tempId!!, chptCnt!!);
      }
      if (typeof pullContentChapters !== "undefined") {
        clearTimeouts();
        toast.remove();
        spinner.hideSpinner();
        setLoading(false);
        return;
      } else {
        console.log("Received unexpected response:", response);
        let t = parseInt(sessionStorage.getItem("tempChTimeout")!!);
        t = t + 5000;
        if (t < 9000000) {
          const id = setTimeout(pollForData, 5000);
          let timeout = timeoutId;
          timeout.push(id);
          setTimeoutId(timeout);
        } else {
          spinner.hideSpinner();
          toast.remove();
          setLoading(false);
        }
      }
    } catch (error) {
      console.error("Error while polling:", error);
      let t = parseInt(sessionStorage.getItem("cardTimeout")!!);
      t = t + 5000;
      if (t < 9000000) {
        const id = setTimeout(pollForData, 5000);
        let timeout = timeoutId;
        timeout.push(id);
        setTimeoutId(timeout);
      } else {
        spinner.hideSpinner();
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    console.log("This is of cards");
    if (timeOut > 30000) {
      clearTimeouts();
    }
  }, [timeOut]);

  const clearTimeouts = () => {
    for (const t of timeoutId) {
      clearTimeout(t);
    }
    timeoutId.length = 0;
  };

  const apiCallGenerativeAiChapters = (
    info: GenerativeAiPost,
    courseId: string
  ) => {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequestWithoutSpinner(
          `${accountInstance.accntId}/course/${courseId}/aicourse/aichapter`,
          "POST",
          info
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("chapter res", res);
          sessionStorage.setItem("courseId", courseId);
          sessionStorage.setItem("chapterscount", info.chapterscount);
          sessionStorage.setItem("temporaryId", info.temporaryId);
          pollForData(courseId, info.chapterscount, info.temporaryId);
        });
    }
  };

  const handleGenerateChapters = () => {};

  // This is only for generativeAiCards CARDS
  const [aiCards, setAiCards] = useState<CourseModuleCards>({
    chapters: [
      {
        cards: [{ cardInfo: { card: [{} as Card] } as CardInfo } as Cards],
      } as CourseChapter,
    ],
  } as CourseModuleCards);

  const [aiCardState, setAiCardState] = useState<boolean>(false);

  const handleAIChapterCardChange = async (
    course: CourseModuleCards
  ): Promise<boolean> => {
    console.log("inside handle ai chapter card change", course);

    let chapters: ManualChapter[] = [];
    for (let courseChapter of course.chapters) {
      let updateChapter = {
        chapterName: courseChapter.chapterName,
        courseId: courseChapter.courseId,
        createdBy: courseChapter.createdBy,
        date: courseChapter.date,
        chapterId: courseChapter.chapterId,
        description: courseChapter.description,
        publishedBy: "",
        publishedDate: courseChapter.date,
        seqNo: courseChapter.seqNo,
        updatedBy: "",
        reviewedBy: "",
        reviewedDate: "",
        cards: courseChapter.cards,
        isLastChapter: courseChapter.isLastChapter,
      };

      for (let card of updateChapter.cards) {
        // @ts-ignore
        delete card.entityId;
        // @ts-ignore
        delete card.status;
        // @ts-ignore
        delete card.createdAt;
        // @ts-ignore
        delete card.date;
        // @ts-ignore
        delete card.chapterName;
        // @ts-ignore
        delete card.entryType;
        // @ts-ignore
        delete card.recType;
        // @ts-ignore
        delete card.updatedAt;
      }

      chapters.push(updateChapter);
    }

    const courseBody = {
      courseName: courseName,
      description: description,
      courseId: course.courseId,
      chapter: chapters,
    };

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      return await api
        .makeRequest(
          // `${accountInstance.accntId}/course/${course.courseId}`,
          `${accountInstance.accntId}/course/${courseId}`,
          "PUT",
          courseBody
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            console.log("I entered update course message 2");
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return false;
          }
          console.log("inside put of navigate");
          return true;
        })
        .catch((err) => {
          return false;
        });
    } else {
      return false;
    }
  };

  const apiCallForFirstSetCards = (
    e: GenerativeAiRequestCards,
    nav: boolean
  ) => {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId && !nav) {
      console.log("when nav is false");
      api
        .makeRequestWithoutSpinner(
          `${accountInstance.accntId}/course/${e.courseId}/aicourse/aicards`,
          "POST",
          e
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("Set Card Pull", res);
          sessionStorage.setItem("cardData", JSON.stringify(e));
          spinner.showSpinner();
          pollCardData(e);
        });
    }
    if (accountInstance.accntId && nav) {
      console.log("when nav is true");
      api
        .makeRequestWithoutSpinner(
          `${accountInstance.accntId}/course/${e.courseId}/aicourse/aicards`,
          "POST",
          e
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          sessionStorage.setItem("cardData", JSON.stringify(e));
        });
      navigate("/courses");
    }
  };

  const apiCallForTheCards = async (e: GenerativeAiRequestCards) => {
    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      api
        .makeRequestWithoutSpinner(
          `${accountInstance.accntId}/course/${courseId}/aicourse/aicards/pullcontent`,
          "POST",
          e
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return;
          }
          console.log("Card Pulled Response", res);
          if (typeof res !== "string") {
            spinner.hideSpinner();
            toast.remove();
            let x = res as CourseModuleCards;
            x.chapters.sort((a, b) => a.seqNo - b.seqNo);
            x.chapters.map((ele) => {
              ele.cards.sort((a, b) => a.seqNo - b.seqNo);
            });
            let response = res as CourseModuleCards;
            response.accntId = accountInstance.accntId;
            setAiCards(response);
            setAiCardState(true);
          }
          return res;
        });
    }
  };

  useEffect(() => {
    if (aiCards.chapters.length >= 1) {
      clearCardTimeout();
      sessionStorage.removeItem("cardData");
    }
  }, [aiCardState, aiCards]);

  const [cardTimeOutIds, setCardTimeOutIds] = useState<number[]>([]);
  sessionStorage.setItem("cardTimeout", (0).toString());
  const pollCardData = async (e: GenerativeAiRequestCards): Promise<void> => {
    try {
      let response;
      if (e) {
        response = await apiCallForTheCards(e);
      } else {
        const cachedData = JSON.parse(sessionStorage.getItem("cardData")!!);
        response = await apiCallForTheCards(cachedData);
      }
      // console.log("Polled Response", pullContentChapters)
      console.log("The type of the response cards", pullContentChapters.typeof);
      if (typeof pullContentChapters === "undefined") {
        spinner.hideSpinner();
        return;
      } else {
        console.log("Received unexpected response:", response);
        let t = parseInt(sessionStorage.getItem("cardTimeout")!!);
        t = t + 5000;
        if (t < 210000) {
          console.log("Setting timeout", t);
          const id = setTimeout(pollCardData, 5000);
          let timeout = cardTimeOutIds;
          timeout.push(id);
          setCardTimeOutIds(timeout);
          sessionStorage.setItem("cardTimeout", t.toString());
        } else {
          spinner.hideSpinner();
          toast.remove();
        }
      }
    } catch (error) {
      console.error("Error while polling:", error);
      let t = parseInt(sessionStorage.getItem("cardTimeout")!!);
      t = t + 5000;
      if (t < 210000) {
        const id = setTimeout(pollCardData, 5000);
        let timeout = cardTimeOutIds;
        timeout.push(id);
        setCardTimeOutIds(timeout);
      } else {
        spinner.hideSpinner();
      }
    }
  };

  const clearCardTimeout = () => {
    for (const t of cardTimeOutIds) {
      clearTimeout(t);
    }
    cardTimeOutIds.length = 0;
  };

  const handleGenerativeAICardRequest = (
    e: GenerativeAiRequestCards,
    nav: boolean
  ) => {
    console.log("Called this function Card request");
    spinner.showSpinner();
    toast.custom(<Loading />, { duration: Infinity });
    apiCallForFirstSetCards(e, nav);
  };

  const validator = {
    courseName: (value: string) =>
      !value
        ? `${intl.formatMessage({
            id: "courses.createCourse.courseNameValidator",
          })}`
        : "",
    description: (value: string) =>
      !value
        ? `${intl.formatMessage({
            id: "courses.createCourse.courseNameDescription",
          })}`
        : "",
    tags: (value: string) =>
      !value
        ? `${intl.formatMessage({
            id: "courses.createCourse.validTags",
          })}`
        : "",
  };

  const handleUpdateStatusAll = async (
    status: string,
    course?: CourseModuleCards
  ): Promise<boolean> => {
    let newCourse = manualCourse;
    if (course) {
      newCourse = course;
    }

    let api = ApiServices.getInstance();
    let chapters: ManualChapter[] = [];
    for (let i = 0; i < newCourse.chapters.length; i++) {
      const courseChapter = newCourse.chapters[i];
      let manualChapter = {
        chapterName: courseChapter.chapterName,
        courseId: courseChapter.courseId,
        createdBy: courseChapter.createdBy,
        date: courseChapter.date,
        chapterId: courseChapter.chapterId,
        description: courseChapter.description,
        publishedBy: "",
        publishedDate: courseChapter.date,
        seqNo: courseChapter.seqNo,
        updatedBy: "",
        reviewedBy: "",
        reviewedDate: "",
        cards: courseChapter.cards,
        isLastChapter: courseChapter.isLastChapter,
        questions: courseChapter.questions,
      };

      for (let card of manualChapter.cards) {
        // @ts-ignore
        delete card.entityId;
        // @ts-ignore
        delete card.status;
        // @ts-ignore
        delete card.createdAt;
        // @ts-ignore
        delete card.date;
        // @ts-ignore
        delete card.chapterName;
        // @ts-ignore
        delete card.entryType;
        // @ts-ignore
        delete card.recType;
        // @ts-ignore
        delete card.updatedAt;
      }

      chapters.push(manualChapter);
    }

    const courseBody = {
      courseId: newCourse.courseId,
      chapter: chapters,
      courseName: courseName,
      description: description,
      status: status,
    };
    if (accountInstance.accntId) {
      return await api
        .makeRequest(
          `${accountInstance.accntId}/course/${newCourse.courseId}/courseUpdStsAll`,
          "POST",
          courseBody
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return false;
          }
          console.log("Manual Course Chapters added in update", res);
          return true;
        })
        .catch((err) => {
          return false;
        });
    } else {
      return false;
    }
  };

  const handleUpdateStatusRev = async (
    status: string,
    course: CourseModuleCards
  ): Promise<boolean> => {
    let chapters: ManualChapter[] = [];
    for (let i = 0; i < course.chapters.length; i++) {
      const courseChapter = course.chapters[i];
      let manualChapter = {
        chapterName: courseChapter.chapterName,
        courseId: courseChapter.courseId,
        createdBy: courseChapter.createdBy,
        date: courseChapter.date,
        chapterId: courseChapter.chapterId,
        description: courseChapter.description,
        publishedBy: "",
        publishedDate: courseChapter.date,
        seqNo: courseChapter.seqNo,
        updatedBy: "",
        reviewedBy: "",
        reviewedDate: "",
        cards: courseChapter.cards,
        isLastChapter: courseChapter.isLastChapter,
        questions: courseChapter.questions,
      };

      for (let card of manualChapter.cards) {
        // @ts-ignore
        delete card.entityId;
        // @ts-ignore
        delete card.status;
        // @ts-ignore
        delete card.createdAt;
        // @ts-ignore
        delete card.date;
        // @ts-ignore
        delete card.chapterName;
        // @ts-ignore
        delete card.entryType;
        // @ts-ignore
        delete card.recType;
        // @ts-ignore
        delete card.updatedAt;
      }

      chapters.push(manualChapter);
    }

    const courseBody = {
      courseId: course.courseId,
      chapter: chapters,
      courseName: courseName,
      description: description,
      status: status,
    };

    let api = ApiServices.getInstance();
    if (accountInstance.accntId) {
      return await api
        .makeRequest(
          `${accountInstance.accntId}/course/${course.courseId}/courseUpdStsRev`,
          "POST",
          courseBody
        )
        .then(async (res) => {
          if (res && res.errorMessage) {
            setErrorFlag(true);
            await errorInstance.updateErrorCode(res.errorMessage);
            return false;
          }
          console.log("Manual Course Chapters added in update", res);
          return true;
        })
        .catch((e) => {
          return false;
        });
    } else {
      return false;
    }
  };

  // This is handleSubmit and it's common for all

  const handleSubmit = async (formData: { [name: string]: any }) => {
    let date = new Date();
    let course: CC = {
      accntId: accountInstance.accntId,
      courseName: formData["courseName"],
      courseId: v4(),
      createdBy: "40c60358-adf4-415c-bed3-f542efd4bbc6",
      date: date.toISOString(),
      publishedBy: "",
      publishedDate: date.toISOString(),
      reviewedBy: "",
      reviewedDate: "",
      updatedBy: "",
      description: formData["description"],
      // tags:formData["tags"],
    };
    if (location.state === generativeAiScreen) {
      if (courseId === undefined) {
        apiCreateGenerativeAiCourse(course, formData["chapterCnt"]);
      }
    }
  };

  return (
    <div className="h-full w-full flex flex-col xl:pb-[7%] pb-[12%]">
      {errorFlag && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: errorInstance.errorCode,
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              setErrorFlag(false);
              // navigate("/courses");
            }}
          />
        </Dialog>
      )}
      {uploadError && (
        <Dialog className="errorDialogue">
          <Alert
            description={intl.formatMessage({
              id: uploadImageError
                ? "course.createCourse.uploadImageError"
                : uploadVideoError
                ? "courses.createCourse.uploadVideoError"
                : uploadAudioError
                ? "courses.createCourse.uploadAudioError"
                : "",
            })}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"errorShape.png"}
            iconMsg={intl.formatMessage({
              id: "iconMsgError",
            })}
            backgroundColor={"mk-red"}
            onClick={() => {
              toggleUploadErrorDialog();
            }}
          />
        </Dialog>
      )}
      {quickSaveDialog && clickSave && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "course.saveChangesSuccess",
            })}`}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"successShape.png"}
            iconMsg={`${intl.formatMessage({
              id: "iconMsgSuccess",
            })}`}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleQuickSaveDialog();
            }}
          />
        </Dialog>
      )}
      {submitDialog && (
        <Dialog className="confirmSuccessDialogue">
          <Alert
            description={`${intl.formatMessage({
              id: "course.submitCourseSuccess",
            })}`}
            buttonText={`${intl.formatMessage({
              id: "users.buttonText.Ok",
            })}`}
            icon={"successShape.png"}
            iconMsg={`${intl.formatMessage({
              id: "iconMsgSuccess",
            })}`}
            backgroundColor={"mk-bright-green"}
            onClick={() => {
              toggleSubmitDialog();
              navigate("/courses");
            }}
          />
        </Dialog>
      )}
      <Form
        onSubmit={handleSubmit}
        render={(formRenderProps: FormRenderProps) => (
          <FormElement className="flex flex-col space-y-4">
            {location.state !== generativeAiFileScreen && (
              <>
                <div>
                  <Field
                    name={"courseName"}
                    id={"courseName"}
                    label={
                      <strong>
                        <FormattedMessage id="courses.onClickCourse.courseName" />
                      </strong>
                    }
                    component={FormLabeledInput}
                    disabled={disableFields}
                    validator={validator.courseName}
                    onChange={(e) => setCourseName(e.value)}
                    className="bg-white w-[25%]"
                  />
                </div>

                <div>
                  <Field
                    name={"description"}
                    id={"description"}
                    label={
                      <strong>{`${
                        disableFields
                          ? `${intl.formatMessage({
                              id: "courses.onClickCourse.description",
                            })}`
                          : `${intl.formatMessage({
                              id: "courses.generativeAi.describe",
                            })}`
                      }`}</strong>
                    }
                    component={FormTextArea}
                    disabled={disableFields}
                    validator={validator.description}
                    onChange={(e) => setDescription(e.value)}
                    className="bg-white w-2/3 "
                  />
                </div>
                <div className={disableFields === true ? "hidden" : "w-[60%]"}>
                  <Field
                    name={"tags"}
                    id={"tags"}
                    label={
                      <strong>
                        <FormattedMessage id="courses.createCourse.tags" />
                      </strong>
                    }
                    component={FormMultiSelectAdd}
                    className="bg-white"
                    // data={["AI", "Testing", "Deployment", "Tech", "Android"]}
                    data={[
                      intl.formatMessage({
                        id: "courses.pdfGeneratvieAi.AI",
                      }),
                      intl.formatMessage({
                        id: "courses.pdfGeneratvieAi.Testing",
                      }),
                      intl.formatMessage({
                        id: "courses.pdfGeneratvieAi.Deployment",
                      }),
                      intl.formatMessage({
                        id: "courses.pdfGeneratvieAi.Tech",
                      }),
                      intl.formatMessage({
                        id: "courses.pdfGeneratvieAi.Android",
                      }),
                    ]}
                  />
                </div>
              </>
            )}

            <div>
              {(() => {
                switch (location.state) {
                  case manualScreen:
                    return (
                      <Manual
                        handleUploadGiveUrl={(e: CourseModuleCards) => {
                          return handleUploadGiveUrl(e);
                        }}
                        handleVideoGeneration={(e: any) => {
                          return handleVideoGeneration(e);
                        }}
                        handleImageGeneration={(e: any) => {
                          return handleImageGeneration(e);
                        }}
                        handleAudioGeneration = {(e:any)=>{
                          return handleAudioGeneration(e)
                        }}
                        duplicateS3File={(
                          sourceKey: string,
                          destinationKey: string,
                          fileType: string
                        ) => {
                          return duplicateS3File(
                            sourceKey,
                            destinationKey,
                            fileType
                          );
                        }}
                        handleCreateCourseUpdateChapterCards={(
                          e: ManualChapter[],
                          manualCourse: CourseModuleCards
                        ): Promise<boolean> => {
                          return handleCreateManualCourse(e, manualCourse);
                        }}
                        manualCourse={manualCourse}
                        oneChapterDeleteFunction={setOneChapterDelete}
                        tenantRole={accountInstance.accntRole}
                        handleUpdateStatusRev={(
                          status: string,
                          course: CourseModuleCards
                        ): Promise<boolean> => {
                          return handleUpdateStatusRev(status, course);
                        }}
                        handleUpdateStatusAll={(
                          status: string,
                          course?: CourseModuleCards
                        ): Promise<boolean> => {
                          return handleUpdateStatusAll(status, course);
                        }}
                      />
                    );
                  case courseCatalogueScreen:
                    return <div></div>;
                  case generativeAiFileScreen:
                    return (
                      <PdfGenerativeAi
                        duplicateS3File={(
                          sourceKey: string,
                          destinationKey: string,
                          fileType: string
                        ) => {
                          return duplicateS3File(
                            sourceKey,
                            destinationKey,
                            fileType
                          );
                        }}
                        handleUpdateStatusAll={(
                          status: string,
                          course?: CourseModuleCards
                        ): Promise<boolean> => {
                          return handleUpdateStatusAll(status, course);
                        }}
                        handleUpdateStatusRev={(
                          status: string,
                          course: CourseModuleCards
                        ): Promise<boolean> => {
                          return handleUpdateStatusRev(status, course);
                        }}
                        handleUploadGiveUrl={(e: CourseModuleCards) => {
                          return handleUploadGiveUrl(e);
                        }}
                      />
                    );
                  default:
                    return (
                      <GenerativeAi
                        duplicateS3File={(
                          sourceKey: string,
                          destinationKey: string,
                          fileType: string
                        ) => {
                          return duplicateS3File(
                            sourceKey,
                            destinationKey,
                            fileType
                          );
                        }}
                        handleUpdateStatusAll={(
                          status: string,
                          course?: CourseModuleCards
                        ): Promise<boolean> => {
                          return handleUpdateStatusAll(status, course);
                        }}
                        handleUpdateStatusRev={(
                          status: string,
                          course: CourseModuleCards
                        ): Promise<boolean> => {
                          return handleUpdateStatusRev(status, course);
                        }}
                        handleUploadGiveUrl={(e: CourseModuleCards) => {
                          return handleUploadGiveUrl(e);
                        }}
                        changeToCardState={aiCardState}
                        handleRequestCard={(
                          e: GenerativeAiRequestCards,
                          nav?: boolean
                        ) => handleGenerativeAICardRequest(e, nav!!)}
                        handleAIChapterCardChange={(
                          e: CourseModuleCards
                        ): Promise<boolean> => {
                          return handleAIChapterCardChange(e);
                        }}
                        cards={aiCards!}
                        chapters={generatedChapters}
                        handleState={() => handleDisableFields()}
                        changeState={disableFields}
                        formRenderProps={formRenderProps}
                      />
                    );
                }
              })()}
            </div>

            {disableFields ? (
              <></>
            ) : (
              <div
                className={`${
                  location.state === manualScreen ||
                  location.state === generativeAiFileScreen
                    ? "hidden"
                    : "w-full flex justify-end items-center"
                }`}
              >
                {/* <div> */}
                <Button
                  themeColor="primary"
                  onClick={() => navigate("/courses")}
                  className="mr-12"
                >
                  <FormattedMessage id="backButton" />
                </Button>
                <Button
                  themeColor="primary"
                  onClick={() => handleGenerateChapters()}
                >
                  <FormattedMessage id="generateChaptersButton" />
                </Button>
              </div>
            )}
          </FormElement>
        )}
      />
    </div>
  );
}
